// 2020 Topps Star Wars Masterwork — GENERATED by pipeline-publish (2026-05-24)
// =============================================================================
// Auto-generated from the set draft. Colors, sub-set types, ordering, and the
// SET_REGISTRY entry below are filled in. REVIEW before committing:
//   - Any placeholder color marker (a parallel name not in the standard color
//     map; the commit guard blocks until every one is resolved).
//   - Rule-7 base serial slots on numbered auto/sketch sub-sets (see in-array
//     notes; the warnings list above flags only sub-sets actually missing one).
//   - Sanity-check the auto-classified sub-set `type` and ordering.
//   - Any placeholder in the SET_REGISTRY entry below (only present if no DB
//     sets row exists for this slug, or fields are blank).
//   - A source/specimen pass on parallel names + print runs.
//   - node --check src/sets/2020-masterwork.js if committing by hand, then commit + push.
//
// SET_REGISTRY entry (paste into src/setRegistry.js):
//   {
//     id: "2020-masterwork",
//     name: "2020 Topps Star Wars Masterwork",
//     shortName: "Masterwork 2020",
//     year: 2020,
//     brand: "Topps",
//     category: 'Star Wars',
//     releaseDate: "2020",
//     totalCards: 497,
//     description: "Topps 2020 Topps Star Wars Masterwork trading card set.",
//     color: "#c9a227",
//     accentColor: "#f0c040",
//     dataFile: "2020-masterwork",
//   },
// =============================================================================

export const SETS = [
  {
    id: "base-cards",
    type: "base",
    title: "BASE CARDS",
    parallels: [
        { id: "blue", name: "Blue", print_run: null, color: "#2979ff" },
        { id: "green", name: "Green", print_run: 99, color: "#00e676" },
        { id: "purple", name: "Purple", print_run: 50, color: "#b060ff" },
        { id: "orange", name: "Orange", print_run: 10, color: "#ff9100" },
        { id: "black", name: "Black", print_run: 5, color: "#a8a8b4" },
        { id: "gold", name: "Gold", print_run: 1, color: "#f0c040" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
      ],
    cards: [
        { n: "1", name: "The Mandalorian" },
        { n: "2", name: "IG-11" },
        { n: "3", name: "Kuiil" },
        { n: "4", name: "Cara Dune" },
        { n: "5", name: "Greef Karga" },
        { n: "6", name: "The Child" },
        { n: "7", name: "The Client" },
        { n: "8", name: "The Armorer" },
        { n: "9", name: "Peli Motto" },
        { n: "10", name: "Moff Gideon" },
        { n: "11", name: "Fennec Shand" },
        { n: "12", name: "Ranzar Malk" },
        { n: "13", name: "Mayfeld" },
        { n: "14", name: "Xi'an" },
        { n: "15", name: "Burg" },
        { n: "16", name: "Qin" },
        { n: "17", name: "Paz Vizsla" },
        { n: "18", name: "Remnant Stormtrooper" },
        { n: "19", name: "Offworld Jawa" },
        { n: "20", name: "Incinerator Trooper" },
        { n: "21", name: "Q9-0" },
        { n: "22", name: "Toro Calican" },
        { n: "23", name: "Rey" },
        { n: "24", name: "Kylo Ren" },
        { n: "25", name: "Finn" },
        { n: "26", name: "Poe Dameron" },
        { n: "27", name: "Lando Calrissian" },
        { n: "28", name: "Jannah" },
        { n: "29", name: "Zorii Bliss" },
        { n: "30", name: "Emperor Palpatine" },
        { n: "31", name: "Allegiant General Pryde" },
        { n: "32", name: "Sith Trooper" },
        { n: "33", name: "D-O" },
        { n: "34", name: "General Hux" },
        { n: "35", name: "Babu Frik" },
        { n: "36", name: "Rose Tico" },
        { n: "37", name: "Klaud" },
        { n: "38", name: "Ushar" },
        { n: "39", name: "Cardo" },
        { n: "40", name: "Kuruk" },
        { n: "41", name: "Vicrul" },
        { n: "42", name: "Trudgen" },
        { n: "43", name: "Ap'lek" },
        { n: "44", name: "Snap Wexley" },
        { n: "45", name: "Kaydel Ko Connix" },
        { n: "46", name: "Maz Kanata" },
        { n: "47", name: "Wedge Antilles" },
        { n: "48", name: "Luke Skywalker" },
        { n: "49", name: "Han Solo" },
        { n: "50", name: "Princess Leia Organa" },
        { n: "51", name: "Darth Vader" },
        { n: "52", name: "C-3PO" },
        { n: "53", name: "R2-D2" },
        { n: "54", name: "Boba Fett" },
        { n: "55", name: "Yoda" },
        { n: "56", name: "Chewbacca" },
        { n: "57", name: "Lando Calrissian" },
        { n: "58", name: "Admiral Piett" },
        { n: "59", name: "Wedge Antilles" },
        { n: "60", name: "Lobot" },
        { n: "61", name: "Wampa" },
        { n: "62", name: "General Veers" },
        { n: "63", name: "Captain Needa" },
        { n: "64", name: "Anakin Skywalker" },
        { n: "65", name: "Obi-Wan Kenobi" },
        { n: "66", name: "Mace Windu" },
        { n: "67", name: "Darth Maul" },
        { n: "68", name: "Count Dooku" },
        { n: "69", name: "Jango Fett" },
        { n: "70", name: "Jar Jar Binks" },
        { n: "71", name: "Cal Kestis" },
        { n: "72", name: "Cere Junda" },
        { n: "73", name: "BD-1" },
        { n: "74", name: "Greez Dritus" },
        { n: "75", name: "Second Sister" },
        { n: "76", name: "Ninth Sister" },
        { n: "77", name: "Merrin" },
        { n: "78", name: "Taron Malicos" },
        { n: "79", name: "Lady Proxima" },
        { n: "80", name: "Rebolt" },
        { n: "81", name: "WG-22" },
        { n: "82", name: "Weazel" },
        { n: "83", name: "Ralakili" },
        { n: "84", name: "Quay Tolsite" },
        { n: "85", name: "Sagwa" },
        { n: "86", name: "Iden Versio" },
        { n: "87", name: "Ahsoka Tano" },
        { n: "88", name: "Commander Cody" },
        { n: "89", name: "Captain Rex" },
        { n: "90", name: "Anakin Skywalker" },
        { n: "91", name: "Obi-Wan Kenobi" },
        { n: "92", name: "Maul" },
        { n: "93", name: "Jyn Erso" },
        { n: "94", name: "Captain Cassian Andor" },
        { n: "95", name: "Baze Malbus" },
        { n: "96", name: "Director Krennic" },
        { n: "97", name: "Galen Erso" },
        { n: "98", name: "Saw Gerrera" },
        { n: "99", name: "Bail Organa" },
        { n: "100", name: "Chirrut Îmwe" },
    ],
  },
  {
    id: "commemorative-dog-tag-medallion-cards",
    type: "insert",
    title: "COMMEMORATIVE DOG TAG MEDALLION CARDS",
    parallels: [
        { id: "purple", name: "Purple", print_run: 50, color: "#b060ff" },
        { id: "orange", name: "Orange", print_run: 10, color: "#ff9100" },
        { id: "black", name: "Black", print_run: 5, color: "#a8a8b4" },
        { id: "gold", name: "Gold", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "DT-EB", name: "Luke Skywalker - X-wing T-65" },
        { n: "DT-ED", name: "Death Star Trooper - Galactic Empire 77" },
        { n: "DT-ES", name: "Commander Daine Jir - Galactic Empire 77" },
        { n: "DT-ET", name: "Stormtrooper - Galactic Empire 77" },
        { n: "DT-EV", name: "Grand Moff Tarkin - Galactic Empire 77" },
        { n: "DT-EX", name: "Sandtrooper - Galactic Empire 77" },
        { n: "DT-FD", name: "Darth Vader - Galactic Empire 77" },
        { n: "DT-FG", name: "Jek Porkins - Red Five 77" },
        { n: "DT-FK", name: "Wedge Antilles - Red Five 77" },
        { n: "DT-FP", name: "Wes Janson - Red Five 77" },
        { n: "DT-FW", name: "Biggs Darklighter - Red Five 77" },
        { n: "DT-FWJ", name: "Derek \"Hobbie\" Klivian - Red Five 77" },
        { n: "DT-HM", name: "Admiral Ozzel - Imperial Infantry Hoth 80" },
        { n: "DT-HO", name: "Admiral Piett - Imperial Infantry Hoth 80" },
        { n: "DT-HP", name: "Garven Dreis - Red Five 77" },
        { n: "DT-JC", name: "Han Solo - Star Wars Rebel 77" },
        { n: "DT-JH", name: "R2-D2 - Star Wars Rebel 77" },
        { n: "DT-JL", name: "Princess Leia Organa - Star Wars Rebel 77" },
        { n: "DT-JP", name: "Chewbacca - Star Wars Rebel 77" },
        { n: "DT-JR", name: "Black One - General Leia Organa" },
        { n: "DT-RB", name: "John D. Branon - Red Five X-Wing Squadron" },
        { n: "DT-RD", name: "Jek Porkins - Red Five X-Wing Squadron" },
        { n: "DT-RJ", name: "General Maximilian Veers - Imperial Infantry Hoth 80" },
        { n: "DT-RK", name: "Wedge Antilles - Red Five X-Wing Squadron" },
        { n: "DT-RP", name: "Wes Janson - Red Five X-Wing Squadron" },
        { n: "DT-RW", name: "Biggs Darklighter - Red Five X-Wing Squadron" },
        { n: "DT-RWJ", name: "Derek \"Hobbie\" Klivian - Red Five X-Wing Squadron" },
        { n: "DT-SD", name: "Luke Skywalker - Star Wars Rebel 77" },
        { n: "DT-SG", name: "Jon \"Dutch\" Vander - Star Wars 77" },
        { n: "DT-SJ", name: "Greedo - Star Wars 77" },
        { n: "DT-SS", name: "Stormtrooper - Stormtrooper" },
        { n: "DT-ST", name: "Darth Vader - Stormtrooper" },
        { n: "DT-SV", name: "Saurin - Star Wars 77" },
        { n: "DT-XL", name: "Wedge Antilles - X-wing T-65" },
        { n: "DT-XW", name: "Offworld Jawa - Star Wars 77" },
    ],
  },
  {
    id: "the-empire-strikes-back-40th-anniversary",
    type: "insert",
    title: "THE EMPIRE STRIKES BACK 40TH ANNIVERSARY",
    parallels: [
        { id: "rainbow-foil", name: "Rainbow Foil", print_run: 299, color: "#c8a4ff" },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "metal", name: "Metal", print_run: 5, color: "#c0c0c8" },
        { id: "gold-metal", name: "Gold Metal", print_run: 1, color: "#f0c040" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
      ],
    cards: [
        { n: "ESB-1", name: "The Ice World of Hoth" },
        { n: "ESB-2", name: "A Very Icy Corridor" },
        { n: "ESB-3", name: "Lair of the Wampa" },
        { n: "ESB-4", name: "Healed by Bacta" },
        { n: "ESB-5", name: "War Against the AT-ATs" },
        { n: "ESB-6", name: "Luke Skywalker's Bravery" },
        { n: "ESB-7", name: "The Millennium Falcon's escape" },
        { n: "ESB-8", name: "Darth Vader's Chamber" },
        { n: "ESB-9", name: "Navigating the Asteroids" },
        { n: "ESB-10", name: "Crash Landing on Dagobah" },
        { n: "ESB-11", name: "Strangeness of the Swamp" },
        { n: "ESB-12", name: "Contacting the Emperor" },
        { n: "ESB-13", name: "The Kiss" },
        { n: "ESB-14", name: "Behemoth in the Asteroid" },
        { n: "ESB-15", name: "A Jedi's Training" },
        { n: "ESB-16", name: "Darkness in the Cave" },
        { n: "ESB-17", name: "Bounty Hunter Assembly" },
        { n: "ESB-18", name: "Lifting the X-Wing" },
        { n: "ESB-19", name: "Boba Fett's Clever Deception" },
        { n: "ESB-20", name: "Dinner with the Dark Lord" },
        { n: "ESB-21", name: "\"I love you.\" \"I know.\"" },
        { n: "ESB-22", name: "Into Carbonite" },
        { n: "ESB-23", name: "Duel on Cloud City" },
        { n: "ESB-24", name: "Darth Vader's Revelation" },
        { n: "ESB-25", name: "The Search for Solo Begins" },
    ],
  },
  {
    id: "animated-signers",
    type: "auto",
    title: "ANIMATED SIGNERS",
    parallels: [
        { id: "blue-foil", name: "Blue Foil", print_run: 99, color: "#4d9fff" },
        { id: "rainbow-foil", name: "Rainbow Foil", print_run: 50, color: "#c8a4ff" },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "silver-frame", name: "Silver Frame", print_run: 5, color: "#bdbdbd" },
        { id: "gold-frame", name: "Gold Frame", print_run: 1, color: "#f0c040" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
      ],
    cards: [
        { n: "MWA-AS-1", name: "Ashley Eckstein as Ahsoka Tano" },
        { n: "MWA-AS-2", name: "Sam Witwer as Emperor Palpatine" },
        { n: "MWA-AS-3", name: "Matthew Wood as Kylo Ren" },
        { n: "MWA-AS-4", name: "Dee Bradley Baker as Bossk" },
        { n: "MWA-AS-5", name: "Janina Gavankar as Iden Versio" },
        { n: "MWA-AS-6", name: "Misty Lee as Princess Leia Organa" },
        { n: "MWA-AS-7", name: "Cameron Monaghan as Cal Kestis" },
        { n: "MWA-AS-8", name: "Debra Wilson as Cere Junda" },
    ],
  },
  {
    id: "behind-the-scenes-signers",
    type: "auto",
    title: "BEHIND THE SCENES SIGNERS",
    parallels: [
        { id: "rainbow-foil", name: "Rainbow Foil", print_run: 50, color: "#c8a4ff" },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "silver-frame", name: "Silver Frame", print_run: 5, color: "#bdbdbd" },
        { id: "gold-frame", name: "Gold Frame", print_run: 1, color: "#f0c040" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
      ],
    cards: [
        { n: "MWA-BTS-1", name: "Ben Burtt - Sound Designer" },
        { n: "MWA-BTS-2", name: "Lee Towersey - Astromech Droid Builder" },
        { n: "MWA-BTS-3", name: "Jake Lunt Davies - CFX Concept Artist" },
        { n: "MWA-BTS-4", name: "Neal Scanlan - CFX Supervisor" },
    ],
  },
  {
    id: "classic-signers",
    type: "auto",
    title: "CLASSIC SIGNERS",
    parallels: [
        { id: "blue-foil", name: "Blue Foil", print_run: 99, color: "#4d9fff" },
        { id: "rainbow-foil", name: "Rainbow Foil", print_run: 50, color: "#c8a4ff" },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "silver-frame", name: "Silver Frame", print_run: 5, color: "#bdbdbd" },
        { id: "gold-frame", name: "Gold Frame", print_run: 1, color: "#f0c040" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
      ],
    cards: [
        { n: "MWA-CS-1", name: "Harrison Ford as Han Solo" },
        { n: "MWA-CS-2", name: "Ian McDiarmid as Emperor Palpatine" },
        { n: "MWA-CS-3", name: "Denis Lawson as Wedge Antilles" },
        { n: "MWA-CS-4", name: "Paul Blake as Greedo" },
        { n: "MWA-CS-5", name: "Michael Pennington as Moff Jerjerrod" },
    ],
  },
  {
    id: "the-mandalorian-signers",
    type: "auto",
    title: "THE MANDALORIAN SIGNERS",
    parallels: [
        { id: "blue-foil", name: "Blue Foil", print_run: 99, color: "#4d9fff" },
        { id: "rainbow-foil", name: "Rainbow Foil", print_run: 50, color: "#c8a4ff" },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "silver-frame", name: "Silver Frame", print_run: 5, color: "#bdbdbd" },
        { id: "gold-frame", name: "Gold Frame", print_run: 1, color: "#f0c040" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
      ],
    cards: [
        { n: "MWA-MS-1", name: "Pedro Pascal as The Mandalorian" },
        { n: "MWA-MS-2", name: "Gina Carano as Cara Dune" },
        { n: "MWA-MS-3", name: "Carl Weathers as Greef Karga" },
        { n: "MWA-MS-4", name: "Giancarlo Esposito as Moff Gideon" },
        { n: "MWA-MS-5", name: "Werner Herzog as The Client" },
        { n: "MWA-MS-6", name: "Taika Waititi as voice of IG-11" },
        { n: "MWA-MS-7", name: "Omid Abtahi as Dr. Pershing" },
        { n: "MWA-MS-8", name: "Emily Swallow as The Armorer" },
    ],
  },
  {
    id: "new-trilogy-signers",
    type: "auto",
    title: "NEW TRILOGY SIGNERS",
    parallels: [
        { id: "blue-foil", name: "Blue Foil", print_run: 99, color: "#4d9fff" },
        { id: "rainbow-foil", name: "Rainbow Foil", print_run: 50, color: "#c8a4ff" },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "silver-frame", name: "Silver Frame", print_run: 5, color: "#bdbdbd" },
        { id: "gold-frame", name: "Gold Frame", print_run: 1, color: "#f0c040" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
      ],
    cards: [
        { n: "MWA-NT-1", name: "Daisy Ridley as Rey" },
        { n: "MWA-NT-2", name: "Adam Driver as Kylo Ren" },
        { n: "MWA-NT-3", name: "Andy Serkis as Supreme Leader Snoke" },
        { n: "MWA-NT-4", name: "Billy Dee Williams as Lando Calrissian" },
        { n: "MWA-NT-5", name: "Joonas Suotamo as Chewbacca" },
        { n: "MWA-NT-6", name: "Billie Lourd as Kaydel Ko Connix" },
        { n: "MWA-NT-7", name: "Dominic Monaghan as Beaumont Kin" },
        { n: "MWA-NT-8", name: "Naomi Ackie as Jannah" },
        { n: "MWA-NT-9", name: "Greg Grunberg as Snap Wexley" },
        { n: "MWA-NT-10", name: "Amanda Hale as Officer Kandia" },
        { n: "MWA-NT-11", name: "Simon Paisley Day as General Quinn" },
        { n: "MWA-NT-12", name: "Geff Francis as Admiral Griss" },
        { n: "MWA-NT-13", name: "Lynn Robertson Bruce as operator for D-O" },
        { n: "MWA-NT-14", name: "Hermione Corfield as Tallie Lintra" },
        { n: "MWA-NT-15", name: "Nick Kellington as Klaud" },
    ],
  },
  {
    id: "prequel-era-signers",
    type: "auto",
    title: "PREQUEL ERA SIGNERS",
    parallels: [
        { id: "blue-foil", name: "Blue Foil", print_run: 99, color: "#4d9fff" },
        { id: "rainbow-foil", name: "Rainbow Foil", print_run: 50, color: "#c8a4ff" },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "silver-frame", name: "Silver Frame", print_run: 5, color: "#bdbdbd" },
        { id: "gold-frame", name: "Gold Frame", print_run: 1, color: "#f0c040" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
      ],
    cards: [
        { n: "MWA-PE-1", name: "Ewan McGregor as Obi-Wan Kenobi" },
        { n: "MWA-PE-2", name: "Hayden Christensen as Anakin Skywalker" },
        { n: "MWA-PE-3", name: "Ahmed Best as Jar Jar Binks" },
        { n: "MWA-PE-4", name: "Leeanna Walsman as Zam Wesell" },
    ],
  },
  {
    id: "rogue-one-solo-signers",
    type: "auto",
    title: "ROGUE ONE & SOLO SIGNERS",
    parallels: [
        { id: "blue-foil", name: "Blue Foil", print_run: 99, color: "#4d9fff" },
        { id: "rainbow-foil", name: "Rainbow Foil", print_run: 50, color: "#c8a4ff" },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "silver-frame", name: "Silver Frame", print_run: 5, color: "#bdbdbd" },
        { id: "gold-frame", name: "Gold Frame", print_run: 1, color: "#f0c040" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
      ],
    cards: [
        { n: "MWA-RS-1", name: "Donnie Yen as Chirrut Îmwe" },
        { n: "MWA-RS-2", name: "Ben Daniels as General Merrick" },
        { n: "MWA-RS-3", name: "Valene Kane as Lyra Erso" },
        { n: "MWA-RS-4", name: "Alden Ehrenreich as Han Solo" },
        { n: "MWA-RS-5", name: "John Tui as Korso" },
        { n: "MWA-RS-6", name: "Erin Kellyman as Enfys Nest" },
        { n: "MWA-RS-7", name: "Annabelle Davis as WG-22" },
    ],
  },
  {
    id: "stamp-cards",
    type: "insert",
    title: "STAMP CARDS",
    parallels: [
        { id: "green", name: "Green", print_run: 99, color: "#00e676" },
        { id: "purple", name: "Purple", print_run: 50, color: "#b060ff" },
        { id: "orange", name: "Orange", print_run: 10, color: "#ff9100" },
        { id: "black", name: "Black", print_run: 5, color: "#a8a8b4" },
        { id: "gold", name: "Gold", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "SC-AA", name: "Anakin Skywalker - Queen Amidala" },
        { n: "SC-AD", name: "Anakin Skywalker - Count Dooku" },
        { n: "SC-AM", name: "Admiral Motti - Grand Moff Tarkin" },
        { n: "SC-BP", name: "BB-8 - Poe Dameron" },
        { n: "SC-CD", name: "Count Dooku - Count Dooku" },
        { n: "SC-CJ", name: "Chewbacca - Jannah" },
        { n: "SC-CZ", name: "C-3PO - Zorii Bliss" },
        { n: "SC-DM", name: "Darth Maul - Darth Maul" },
        { n: "SC-FP", name: "Finn - Poe Dameron" },
        { n: "SC-JJ", name: "Jannah - Jannah" },
        { n: "SC-JS", name: "Sith Jet Trooper - Sith Trooper" },
        { n: "SC-KS", name: "Kylo Ren - Sith Trooper" },
        { n: "SC-LC", name: "Lando Calrissian - Lando Calrissian" },
        { n: "SC-LJ", name: "Lando Calrissian - Jannah" },
        { n: "SC-LL", name: "Lobot - Lando Calrissian" },
        { n: "SC-LW", name: "Logray - Wicket W. Warrick" },
        { n: "SC-MM", name: "Grand Moff Tarkin - Grand Moff Tarkin" },
        { n: "SC-OM", name: "Obi-Wan Kenobi - Darth Maul" },
        { n: "SC-PD", name: "Poe Dameron - Poe Dameron" },
        { n: "SC-PLW", name: "Princess Leia Organa - Wicket W. Warrick" },
        { n: "SC-PZ", name: "Poe Dameron - Zorii Bliss" },
        { n: "SC-QA", name: "Queen Amidala - Queen Amidala" },
        { n: "SC-QM", name: "Qui-Gon Jinn - Darth Maul" },
        { n: "SC-SA", name: "Sabé - Queen Amidala" },
        { n: "SC-SL", name: "Stormtrooper - Lando Calrissian" },
        { n: "SC-SS", name: "Sith Trooper - Sith Trooper" },
        { n: "SC-VM", name: "Darth Vader - Grand Moff Tarkin" },
        { n: "SC-WW", name: "Wicket W. Warrick - Wicket W. Warrick" },
        { n: "SC-YD", name: "Yoda - Count Dooku" },
        { n: "SC-ZB", name: "Zorii Bliss - Zorii Bliss" },
    ],
  },
  {
    id: "troopers-of-the-galactic-empire",
    type: "insert",
    title: "TROOPERS OF THE GALACTIC EMPIRE",
    parallels: [
        { id: "rainbow-foil", name: "Rainbow Foil", print_run: 299, color: "#c8a4ff" },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "metal", name: "Metal", print_run: 5, color: "#c0c0c8" },
        { id: "gold-metal", name: "Gold Metal", print_run: 1, color: "#f0c040" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
      ],
    cards: [
        { n: "TE-1", name: "Imperial Stormtrooper" },
        { n: "TE-2", name: "Imperial Snowtrooper" },
        { n: "TE-3", name: "Imperial TIE Fighter Pilot" },
        { n: "TE-4", name: "Imperial Royal Guard" },
        { n: "TE-5", name: "Imperial Scout Trooper" },
        { n: "TE-6", name: "Imperial Shoretrooper" },
        { n: "TE-7", name: "Imperial AT-AT Pilot" },
        { n: "TE-8", name: "Imperial Death Star Gunner" },
        { n: "TE-9", name: "Imperial Sandtrooper" },
        { n: "TE-10", name: "Imperial Death Trooper" },
        { n: "TE-11", name: "Imperial Navy Trooper" },
        { n: "TE-12", name: "Imperial Tank Driver" },
        { n: "TE-13", name: "Imperial Mudtrooper" },
        { n: "TE-14", name: "Imperial Patrol Trooper" },
        { n: "TE-15", name: "Imperial Range Trooper" },
    ],
  },
  {
    id: "the-wisdom-of-yoda",
    type: "insert",
    title: "THE WISDOM OF YODA",
    parallels: [
        { id: "rainbow-foil", name: "Rainbow Foil", print_run: 299, color: "#c8a4ff" },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "metal", name: "Metal", print_run: 5, color: "#c0c0c8" },
        { id: "gold-metal", name: "Gold Metal", print_run: 1, color: "#f0c040" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
      ],
    cards: [
        { n: "WY-1", name: "\"Do. Or do not. There is no try.\"" },
        { n: "WY-2", name: "\"That is why you fail.\"" },
        { n: "WY-3", name: "\"Once you start down that dark path, forever will it dominate your destiny.\"" },
        { n: "WY-4", name: "\"A Jedi uses the Force for knowledge and defense, never for attack.\"" },
        { n: "WY-5", name: "\"Death is a natural part of life.\"" },
        { n: "WY-6", name: "\"Size matters not.\"" },
        { n: "WY-7", name: "\"You will know, when you are calm, at peace.\"" },
        { n: "WY-8", name: "\"Impossible to see, the future is.\"" },
        { n: "WY-9", name: "\"The greatest teacher failure is.\"" },
        { n: "WY-10", name: "\"Fear is the path to the dark side. Fear leads to anger...\"" },
    ],
  },
  {
    id: "behind-the-scenes-pen-auto-relic",
    type: "auto",
    title: "BEHIND THE SCENES PEN AUTO RELIC",
    parallels: [
        // TODO (rule 7): if this sub-set's BASE card is numbered, add a
        // blank-name serial slot at the base print run, e.g.
        //   { id: 'base', name: '', print_run: <N>, color: '#c8d8f0' },
        { id: "one-of-one", name: "", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "BTSPR-1", name: "Ben Burtt - Sound Designer" },
        { n: "BTSPR-2", name: "Lee Towersey - Astromech Droid Builder" },
        { n: "BTSPR-3", name: "Jake Lunt Davies - CFX Concept Artist" },
        { n: "BTSPR-4", name: "Neal Scanlan - CFX Supervisor" },
    ],
  },
  {
    id: "commemorative-dog-tag-autographs",
    type: "auto",
    title: "COMMEMORATIVE DOG TAG AUTOGRAPHS",
    parallels: [
        // TODO (rule 7): if this sub-set's BASE card is numbered, add a
        // blank-name serial slot at the base print run, e.g.
        //   { id: 'base', name: '', print_run: <N>, color: '#c8d8f0' },
        { id: "purple", name: "Purple", print_run: 50, color: "#b060ff" },
        { id: "orange", name: "Orange", print_run: 10, color: "#ff9100" },
        { id: "black", name: "Black", print_run: 5, color: "#a8a8b4" },
        { id: "gold", name: "Gold", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "CDA-1", name: "Denis Lawson as Wedge Antilles" },
        { n: "CDA-2", name: "Garrick Hagon as Biggs Darklighter" },
        { n: "CDA-3", name: "Jack Klaff as John D. Branon" },
        { n: "CDA-4", name: "Julian Glover as General Veers" },
        { n: "CDA-5", name: "Kenneth Colley as Admiral Piett" },
        { n: "CDA-6", name: "Denis Lawson as Wedge Antilles" },
        { n: "CDA-7", name: "Garrick Hagon as Biggs Darklighter" },
        { n: "CDA-8", name: "Jack Klaff as John D. Branon" },
        { n: "CDA-9", name: "Anthony Forrest as Sandtrooper" },
        { n: "CDA-10", name: "Denis Lawson as Wedge Antilles" },
        { n: "CDA-11", name: "Rusty Goffe as Offworld Jawa" },
        { n: "CDA-12", name: "Paul Blake as Greedo" },
        { n: "CDA-13", name: "Angus MacInnes as Jon \"Dutch\" Vander" },
        { n: "CDA-14", name: "Barbara Frankland as Saurin" },
        { n: "CDA-15", name: "Carrie Fisher as Princess Leia Organa" },
        { n: "CDA-16", name: "Peter Mayhew as Chewbacca" },
        { n: "CDA-17", name: "Harrison Ford as Han Solo" },
        { n: "CDA-18", name: "Kenny Baker as R2-D2" },
    ],
  },
  {
    id: "sourced-fabric-dual-relic-cards",
    type: "auto",
    title: "SOURCED FABRIC DUAL RELIC CARDS",
    parallels: [
        // TODO (rule 7): if this sub-set's BASE card is numbered, add a
        // blank-name serial slot at the base print run, e.g.
        //   { id: 'base', name: '', print_run: <N>, color: '#c8d8f0' },
        { id: "purple", name: "Purple", print_run: 25, color: "#b060ff" },
        { id: "orange", name: "Orange", print_run: 10, color: "#ff9100" },
        { id: "black", name: "Black", print_run: 5, color: "#a8a8b4" },
        { id: "gold", name: "Gold", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "DC-BD", name: "Beckett & Dryden Vos" },
        { n: "DC-BQ", name: "Beckett & Qi'ra" },
        { n: "DC-DQ", name: "Dryden Vos & Qi'ra" },
        { n: "DC-FD", name: "Finn & DJ" },
        { n: "DC-FR", name: "Finn & Rose Tico" },
        { n: "DC-JB", name: "Jyn Erso & Bodhi Rook" },
        { n: "DC-JG", name: "Jyn Erso & Galen Erso" },
        { n: "DC-JM", name: "Jyn Erso & General Merrick" },
        { n: "DC-LF", name: "Luke Skywalker & Finn" },
        { n: "DC-LP", name: "Luke Skywalker & Poe Dameron" },
        { n: "DC-PF", name: "Poe Dameron & Finn" },
        { n: "DC-PG", name: "Poe Dameron & General Hux" },
        { n: "DC-RD", name: "Rose Tico & DJ" },
        { n: "DC-RP", name: "Rey & Poe Dameron" },
        { n: "DC-RPJ", name: "Rey & Poe Dameron" },
        { n: "DC-RPW", name: "Rey & Poe Dameron" },
    ],
  },
  {
    id: "dual-autograph-cards",
    type: "auto",
    title: "DUAL AUTOGRAPH CARDS",
    parallels: [
        // TODO (rule 7): if this sub-set's BASE card is numbered, add a
        // blank-name serial slot at the base print run, e.g.
        //   { id: 'base', name: '', print_run: <N>, color: '#c8d8f0' },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "black", name: "Black", print_run: 5, color: "#a8a8b4" },
        { id: "gold", name: "Gold", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "MWD-1", name: "Ewan McGregor / Samuel L. Jackson as Obi-Wan Kenobi / Mace Windu" },
        { n: "MWD-2", name: "Harrison Ford / Adam Driver as Han Solo / Kylo Ren" },
        { n: "MWD-3", name: "Pedro Pascal / Nick Nolte as The Mandalorian / voice of Kuiil" },
        { n: "MWD-4", name: "Pedro Pascal / Taika Waititi as The Mandalorian / voice of IG-11" },
        { n: "MWD-5", name: "Felicity Jones / Donnie Yen as Jyn Erso / Chirrut Îmwe" },
        { n: "MWD-6", name: "Forest Whitaker / Riz Ahmed as Saw Gerrera / Bodhi Rook" },
        { n: "MWD-7", name: "Alden Ehrenreich / Erin Kellyman as Han Solo / Enfys Nest" },
        { n: "MWD-8", name: "Temuera Morrison / Leeanna Walsman as Jango Fett / Zam Wesell" },
        { n: "MWD-9", name: "Cameron Monaghan / Debra Wilson as Cal Kestis / Cere Junda" },
        { n: "MWD-10", name: "Alan Harris / Chris Parsons as Bossk / 4-LOM" },
        { n: "MWD-11", name: "Ashley Eckstein / Jaime King as Ahsoka Tano / Aurra Sing" },
        { n: "MWD-12", name: "Harley Durst / Derek Arnold as Moloch / Argus \"Six Eyes\" Panox" },
        { n: "MWD-13", name: "Robin Atkin Downes / Vanessa Marshall as Cham Syndulla / Hera Syndulla" },
        { n: "MWD-14", name: "Caroline Blakiston / Dermot Crowley as Mon Mothma / General Crix Madine" },
        { n: "MWD-15", name: "Nika Futterman / Olivia d'Abo as Asajj Ventress / Luminara Unduli" },
        { n: "MWD-16", name: "Christopher Sean / Donald Faison as Kazuda Xiono / Hype Fazon" },
        { n: "MWD-17", name: "Harley Durst / Ian Kenny as Moloch / Rebolt" },
        { n: "MWD-18", name: "Erin Kellyman / Warwick Davis as Enfys Nest / Weazel" },
        { n: "MWD-19", name: "Sema-Tawi Smart / Charlotte Louise as Aurodia Ventafoli / Margo" },
    ],
  },
  {
    id: "quad-autograph-book-cards",
    type: "auto",
    title: "QUAD AUTOGRAPH BOOK CARDS",
    parallels: [
        // TODO (rule 7): if this sub-set's BASE card is numbered, add a
        // blank-name serial slot at the base print run, e.g.
        //   { id: 'base', name: '', print_run: <N>, color: '#c8d8f0' },
        { id: "one-of-one", name: "", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "MWQ-1", name: "Harrison Ford / Carrie Fisher / Kenny Baker / Peter Mayhew" },
        { n: "MWQ-2", name: "Daisy Ridley / Billy Dee Williams / Adam Driver / John Boyega" },
        { n: "MWQ-3", name: "Pedro Pascal / Gina Carano / Nick Nolte / Taika Waititi" },
        { n: "MWQ-4", name: "Nick Nolte / Gina Carano / Werner Herzog / Giancarlo Esposito" },
    ],
  },
  {
    id: "triple-autograph-cards",
    type: "auto",
    title: "TRIPLE AUTOGRAPH CARDS",
    parallels: [
        // TODO (rule 7): if this sub-set's BASE card is numbered, add a
        // blank-name serial slot at the base print run, e.g.
        //   { id: 'base', name: '', print_run: <N>, color: '#c8d8f0' },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "black", name: "Black", print_run: 5, color: "#a8a8b4" },
        { id: "gold", name: "Gold", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "MWT-1", name: "Harrison Ford / Carrie Fisher / Peter Mayhew as Han Solo / Princess Leia Organa / Chewbacca" },
        { n: "MWT-2", name: "Pedro Pascal / Nick Nolte / Taika Waititi as The Mandalorian / voice of Kuiil / voice of IG-11" },
        { n: "MWT-3", name: "Ewan McGregor / Samuel L. Jackson / Hayden Christensen as Obi-Wan Kenobi / Mace Windu / Anakin Skywalker" },
        { n: "MWT-4", name: "Adam Driver / Domhnall Gleeson / Gwendoline Christie as Kylo Ren / General Hux / Captain Phasma" },
        { n: "MWT-5", name: "Felicity Jones / Forest Whitaker / Donnie Yen as Jyn Erso / Saw Gerrera / Chirrut Îmwe" },
        { n: "MWT-6", name: "Harrison Ford / Billy Dee Williams / Jeremy Bulloch as Han Solo / Lando Calrissian / Boba Fett" },
        { n: "MWT-7", name: "Tom Baker / Freddie Prinze Jr. / Taylor Gray as Bendu / Kanan Jarrus / Ezra Bridger" },
        { n: "MWT-8", name: "John Boyega / Kelly Marie Tran / Billie Lourd as Finn / Rose Tico / Kaydel Ko Connix" },
        { n: "MWT-9", name: "Barbara Goodson / Nika Futterman / Kathleen Gati as Mother Talzin / Asajj Ventress / Old Daka" },
        { n: "MWT-10", name: "Tim Curry / Matt Lanter / Ashley Eckstein as Chancellor Palpatine / Anakin Skywalker / Ahsoka Tano" },
        { n: "MWT-11", name: "Christopher Sean / Suzie McGrath / Donald Faison as Kazuda Xiono / Tam Ryvora / Hype Fazon" },
    ],
  },
  {
    id: "ultra-autograph-cards",
    type: "auto",
    title: "ULTRA AUTOGRAPH CARDS",
    parallels: [
        // TODO (rule 7): if this sub-set's BASE card is numbered, add a
        // blank-name serial slot at the base print run, e.g.
        //   { id: 'base', name: '', print_run: <N>, color: '#c8d8f0' },
        { id: "one-of-one", name: "", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "MWU-1", name: "Harrison Ford / Carrie Fisher / Billy Dee Williams / Peter Mayhew / Kenny Baker / Ian McDiarmid / Caroline Blakiston / Jeremy Bulloch / Denis Lawson / Warwick Davis" },
        { n: "MWU-2", name: "Daisy Ridley / Adam Driver / John Boyega / Kelly Marie Tran / Billy Dee Williams / Joonas Suotamo / Domhnall Gleeson / Ian McDiarmid / Dominic Monaghan / Billie Lourd" },
        { n: "MWU-3", name: "Felicity Jones / Ben Mendelsohn / Forest Whitaker / Donnie Yen / Riz Ahmed / Alan Tudyk / Genevieve O'Reilly / Mads Mikkelsen / Guy Henry / Ben Daniels" },
    ],
  },
  {
    id: "pen-relic-autographs",
    type: "auto",
    title: "PEN RELIC AUTOGRAPHS",
    parallels: [
        // TODO (rule 7): if this sub-set's BASE card is numbered, add a
        // blank-name serial slot at the base print run, e.g.
        //   { id: 'base', name: '', print_run: <N>, color: '#c8d8f0' },
        { id: "one-of-one", name: "", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "PRA-1", name: "Harrison Ford as Han Solo" },
        { n: "PRA-2", name: "Ian McDiarmid as Emperor Palpatine" },
        { n: "PRA-3", name: "Denis Lawson as Wedge Antilles" },
        { n: "PRA-4", name: "Paul Blake as Greedo" },
        { n: "PRA-5", name: "Michael Pennington as Moff Jerjerrod" },
        { n: "PRA-6", name: "Alden Ehrenreich as Han Solo" },
        { n: "PRA-7", name: "John Tui as Korso" },
        { n: "PRA-8", name: "Erin Kellyman as Enfys Nest" },
        { n: "PRA-9", name: "Annabelle Davis as WG-22" },
        { n: "PRA-10", name: "Pedro Pascal as The Mandalorian" },
        { n: "PRA-11", name: "Gina Carano as Cara Dune" },
        { n: "PRA-12", name: "Carl Weathers as Greef Karga" },
        { n: "PRA-13", name: "Giancarlo Esposito as Moff Gideon" },
        { n: "PRA-14", name: "Werner Herzog as The Client" },
        { n: "PRA-15", name: "Nick Nolte as Kuiil" },
        { n: "PRA-16", name: "Emily Swallow as The Armorer" },
        { n: "PRA-17", name: "Omid Abtahi as Dr. Pershing" },
        { n: "PRA-18", name: "Taika Waititi as voice of IG-11" },
        { n: "PRA-19", name: "Mads Mikkelsen as Galen Erso" },
        { n: "PRA-20", name: "Donnie Yen as Chirrut Îmwe" },
        { n: "PRA-21", name: "Ben Daniels as General Merrick" },
        { n: "PRA-22", name: "Valene Kane as Lyra Erso" },
        { n: "PRA-23", name: "Billy Dee Williams as Lando Calrissian" },
        { n: "PRA-24", name: "Joonas Suotamo as Chewbacca" },
        { n: "PRA-25", name: "Nick Kellington as Klaud" },
        { n: "PRA-26", name: "Daisy Ridley as Rey" },
        { n: "PRA-27", name: "Adam Driver as Kylo Ren" },
        { n: "PRA-28", name: "Billie Lourd as Kaydel Ko Connix" },
        { n: "PRA-29", name: "Dominic Monaghan as Beaumont Kin" },
        { n: "PRA-30", name: "Naomi Ackie as Jannah" },
        { n: "PRA-31", name: "Greg Grunberg as Snap Wexley" },
        { n: "PRA-32", name: "Hermione Corfield as Tallie Lintra" },
        { n: "PRA-33", name: "Andy Serkis as Supreme Leader Snoke" },
        { n: "PRA-34", name: "Ahmed Best as Jar Jar Binks" },
        { n: "PRA-35", name: "Ewan McGregor as Obi-Wan Kenobi" },
        { n: "PRA-36", name: "Ashley Eckstein as Ahsoka Tano" },
        { n: "PRA-37", name: "Sam Witwer as Emperor Palpatine" },
        { n: "PRA-38", name: "Dee Bradley Baker as Bossk" },
        { n: "PRA-39", name: "Janina Gavankar as Iden Versio" },
        { n: "PRA-40", name: "Cameron Monaghan as Cal Kestis" },
        { n: "PRA-41", name: "Debra Wilson as Cere Junda" },
        { n: "PRA-42", name: "Leeanna Walsman as Zam Wesell" },
        { n: "PRA-43", name: "Hayden Christensen as Anakin Skywalker" },
    ],
  },
  {
    id: "sketch-cards",
    type: "sketch",
    title: "SKETCH CARDS",
    parallels: [
        // TODO (rule 7): if this sub-set's BASE card is numbered, add a
        // blank-name serial slot at the base print run, e.g.
        //   { id: 'base', name: '', print_run: <N>, color: '#c8d8f0' },
        { id: "one-of-one", name: "", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "SK-1", name: "Jeff Abar" },
        { n: "SK-2", name: "Jason Adams" },
        { n: "SK-3", name: "Marlo Agunos" },
        { n: "SK-4", name: "Steve Alce" },
        { n: "SK-5", name: "Thomas Amici" },
        { n: "SK-6", name: "Angel Aviles" },
        { n: "SK-7", name: "Kelly Baber" },
        { n: "SK-8", name: "Jerold Bahr" },
        { n: "SK-9", name: "Quinton Baker" },
        { n: "SK-10", name: "Norviento Basio" },
        { n: "SK-11", name: "Adam Beck" },
        { n: "SK-12", name: "Jonathan Beistline" },
        { n: "SK-13", name: "Angelina Benedetti" },
        { n: "SK-14", name: "Bobby Blakey" },
        { n: "SK-15", name: "Brandon Blevins" },
        { n: "SK-16", name: "Ashlee Brienzo" },
        { n: "SK-17", name: "John Bruce" },
        { n: "SK-18", name: "Semra Bulut" },
        { n: "SK-19", name: "Carlos Cabaleiro" },
        { n: "SK-20", name: "Neil Camera" },
        { n: "SK-21", name: "Dwayne Carpenter" },
        { n: "SK-22", name: "Patricio Carrasco" },
        { n: "SK-23", name: "Başak Çetinkaya" },
        { n: "SK-24", name: "Oscar Chavez" },
        { n: "SK-25", name: "Kevin Cleveland" },
        { n: "SK-26", name: "Chris Colyer" },
        { n: "SK-27", name: "Jamie Cosley" },
        { n: "SK-28", name: "Aston Cover" },
        { n: "SK-29", name: "Ronnie Crowther" },
        { n: "SK-30", name: "Candice Dailey" },
        { n: "SK-31", name: "Jason Davies" },
        { n: "SK-32", name: "Vincenzo D'Ippolito" },
        { n: "SK-33", name: "Garrett Dix" },
        { n: "SK-34", name: "Dean Drummond" },
        { n: "SK-35", name: "Marcia Dye" },
        { n: "SK-36", name: "Antni Ellison" },
        { n: "SK-37", name: "Gabe Farber" },
        { n: "SK-38", name: "Keith Farnum" },
        { n: "SK-39", name: "Brett Farr" },
        { n: "SK-40", name: "Rees Finlay" },
        { n: "SK-41", name: "Ryan Finley" },
        { n: "SK-42", name: "Dave Fowler" },
        { n: "SK-43", name: "Andrew Fry" },
        { n: "SK-44", name: "Jude Gallagher" },
        { n: "SK-45", name: "Robert Garcia" },
        { n: "SK-46", name: "Jonty Gates" },
        { n: "SK-47", name: "Mick and Matt Glebe" },
        { n: "SK-48", name: "Sammy Gomez" },
        { n: "SK-49", name: "Fredd Gorham" },
        { n: "SK-50", name: "Dan Gorman" },
        { n: "SK-51", name: "Lindsey Greyling" },
        { n: "SK-52", name: "Nick Gribbon" },
        { n: "SK-53", name: "Allen Grimes" },
        { n: "SK-54", name: "Ingrid Hardy" },
        { n: "SK-55", name: "Robert Hendrickson" },
        { n: "SK-56", name: "Rich Hennemann" },
        { n: "SK-57", name: "Jessica Hickman" },
        { n: "SK-58", name: "Matthew Hirons" },
        { n: "SK-59", name: "Brad Hudson" },
        { n: "SK-60", name: "Mai Irving" },
        { n: "SK-61", name: "Mohammad Jilani" },
        { n: "SK-62", name: "Karl Jones" },
        { n: "SK-63", name: "Chris Kay" },
        { n: "SK-64", name: "Joshua Caleb King" },
        { n: "SK-65", name: "Eric Lehtonen" },
        { n: "SK-66", name: "Benjamin Lombart" },
        { n: "SK-67", name: "Paul Maitland" },
        { n: "SK-68", name: "Jay Manchand" },
        { n: "SK-69", name: "Ashley Marsh" },
        { n: "SK-70", name: "Michael Mastermaker" },
        { n: "SK-71", name: "Jim Mehsling" },
        { n: "SK-72", name: "Solly Mohamed" },
        { n: "SK-73", name: "Logan Monette" },
        { n: "SK-74", name: "Jason Montoya" },
        { n: "SK-75", name: "Michael Munshaw" },
        { n: "SK-76", name: "Jamie Murdock" },
        { n: "SK-77", name: "Dawn Murphy" },
        { n: "SK-78", name: "Mark Necchi" },
        { n: "SK-79", name: "Marsha Parkins" },
        { n: "SK-80", name: "Don Pedicini Jr." },
        { n: "SK-81", name: "Darrin Pepe" },
        { n: "SK-82", name: "Lucas Peverill" },
        { n: "SK-83", name: "John Pleak" },
        { n: "SK-84", name: "Jason Queen" },
        { n: "SK-85", name: "Michelle Rayner" },
        { n: "SK-86", name: "Barry Renshaw" },
        { n: "SK-87", name: "Jamie Richards" },
        { n: "SK-88", name: "Daniel Riveron" },
        { n: "SK-89", name: "Rodney Roberts" },
        { n: "SK-90", name: "Guilherme Rocha" },
        { n: "SK-91", name: "Luke Rushton" },
        { n: "SK-92", name: "Andrew Sanchez" },
        { n: "SK-93", name: "Frank Sansone" },
        { n: "SK-94", name: "Ryan Santos" },
        { n: "SK-95", name: "Richard Serrao" },
        { n: "SK-96", name: "Mayumi Seto" },
        { n: "SK-97", name: "Anil Sharma" },
        { n: "SK-98", name: "Cyrus Sherkat" },
        { n: "SK-99", name: "Paul Shiers" },
        { n: "SK-100", name: "Tim Shinn" },
        { n: "SK-101", name: "Ward Silverman" },
        { n: "SK-102", name: "Shaow Siong" },
        { n: "SK-103", name: "Anthony Skubis" },
        { n: "SK-104", name: "Matt Stewart" },
        { n: "SK-105", name: "Dan Tearle" },
        { n: "SK-106", name: "Rob Teranishi" },
        { n: "SK-107", name: "Phillip Trujillo" },
        { n: "SK-108", name: "Huy Truong" },
        { n: "SK-109", name: "Wayne Tully" },
        { n: "SK-110", name: "Kevin P. West" },
        { n: "SK-111", name: "Trent Westbrook" },
        { n: "SK-112", name: "Gavin Williams" },
        { n: "SK-113", name: "Zach Woolsey" },
    ],
  },
];

export const ALL_CARD_KEYS = SETS.flatMap(set =>
  set.cards.map(card => `${set.id}__${card.n}`)
);

// Fallback exports used by Checklist.js for any sub-set with no inline `parallels`.
// Every sub-set above has its own inline array, so these stay empty.
export const PARALLELS = [];
export const AUTO_PARALLELS = [];
export const INSERT_PARALLELS = [];
